import React from 'react';
import './Preloader.css';

const Preloader = () => {
  return (
    <div
      id="ftco-loader_preloader"
      className="show_preloader fullscreen_preloader"
    >
      <svg className="circular_preloader" width="48px" height="48px">
        <circle
          className="path-bg"
          cx={24}
          cy={24}
          r={22}
          fill="none"
          strokeWidth={4}
          stroke="#eeeeee"
        />
        <circle
          className="path_preloader"
          cx={24}
          cy={24}
          r={22}
          fill="none"
          strokeWidth={4}
          strokeMiterlimit={10}
          stroke="#6db549"
        />
      </svg>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 3000 964"
        enableBackground="new 0 0 955 364"
        xmlSpace="preserve"
        style={{
          // paddingLeft: 'calc(46vw - 130px)',
          // paddingLeft: '40vw',
          position: 'absolute',
          top: '50vh',
          minWidth: '600px',
          maxWidth: '1000px',
        }}
      >
        <g id="itall">
          <path
            fill="#586477"
            d="M493,2.806h-28.464V92H6.266v34.157h167.595v231.265h28.464v-0.717h19.736
      c0-117.94,115.158-213.892,256.706-213.892c141.548,0,256.706,95.951,256.706,213.892h22.015v0.717h28.464V126.157h165.316V92H493
      V2.806z M265.136,170.584c-26.355,22.331-47.456,48.176-62.811,76.896V126.157h132.86
      C309.782,137.857,286.196,152.74,265.136,170.584z M757.489,251.876c-15.519-30.482-37.399-57.828-65.089-81.292
      c-21.059-17.844-44.646-32.727-70.049-44.427h135.139V251.876z"
          />
          <g
            transform="translate(0 -100)"
            x={200}
            className="left_paddle_preloader"
          >
            <path
              fill="#586477"
              d="M30.998,85.012l36.393,24.258c6.871,1.171,14.101,0.905,21.269-1.053
        c13.899-3.798,24.778-13.168,30.895-25.039c3.058-4.859,5.262-10.243,6.488-15.906c2.462-8.453,2.7-17.67,0.208-26.785
        C119.062,14.168,91.901-1.338,65.583,5.853c-9.393,2.566-17.4,7.685-23.498,14.395c-3.357,3.121-6.245,6.681-8.601,10.562
        c-8.465,11.699-11.761,26.98-7.659,41.996C27.025,77.196,28.784,81.279,30.998,85.012z"
            />
            <path
              fill="#586477"
              d="M19.483,154.73l25.231-37.61c1.956-1.853,5.284-4.845,12.144-6.557l-24.37-16.245
        c0.186,2.742,0.149,7.366-1.68,11.036c-0.204,0.231-26.669,39.08-26.669,39.08c-2.46,3.666-2.109,5.003,2.04,7.788l5.324,3.57
        C15.653,158.578,17.022,158.395,19.483,154.73z"
            />
          </g>
          <g transform="translate(790 -100)" className="right_paddle_preloader">
            <path
              fill="#586477"
              d="M99.609,85.012L63.216,109.27c-6.871,1.171-14.101,0.905-21.269-1.053
        c-13.899-3.798-24.778-13.168-30.895-25.039C7.995,78.318,5.79,72.935,4.564,67.271c-2.462-8.453-2.7-17.67-0.208-26.785
        C11.544,14.168,38.706-1.338,65.023,5.853c9.393,2.566,17.4,7.685,23.498,14.395c3.357,3.121,6.245,6.681,8.601,10.562
        c8.465,11.699,11.761,26.98,7.659,41.996C103.582,77.196,101.823,81.279,99.609,85.012z"
            />
            <path
              fill="#586477"
              d="M111.124,154.73l-25.231-37.61c-1.956-1.853-5.284-4.845-12.144-6.557l24.37-16.245
        c-0.186,2.742-0.148,7.366,1.68,11.036c0.204,0.231,26.669,39.08,26.669,39.08c2.46,3.666,2.109,5.003-2.04,7.788l-5.324,3.57
        C114.954,158.578,113.584,158.395,111.124,154.73z"
            />
          </g>
          <g className="ball_preloader">
            <circle
              transform="translate(60 -50)"
              fill="#ED3A67"
              cx="24.999"
              cy={25}
              r="21.386"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Preloader;
